import { useCallback, type ReactNode } from "react"
import { DatasetDetails } from "./sections/DatasetDetails"
import { LicenseDuration } from "./sections/LicenseDuration"
import { Step } from "./Step"
import { Steps } from "./Steps"
import { useBuilderForm } from "@/hooks/useBuilderForm"
import { useStrings } from "@/hooks/useStrings"
import { Sharing } from "./sections/Sharing"
import { BenefitSharing } from "./sections/BenefitSharing"
import { CostRecovery } from "./sections/CostRecovery"
import { Publishing } from "./sections/Publishing"
import { Widget } from "./Widget"
import { Attribution } from "./sections/Attribution"
import { Conditions } from "./sections/Conditions"

const step = (title:string|undefined, form:ReactNode, stepProps?:any) => (<Step key={title} title={title} {...stepProps}>{form}</Step>)

export const Builder = ({ widgetVisible }: { widgetVisible: boolean }) => {
  const s = useStrings()
  const titles = s.sectionTitle
  const { form, resetForm } = useBuilderForm()
  const handleReset = useCallback(() => {
    if (typeof window === "undefined") return
    const confirmed = window.confirm("Reset all license fields? This clears your saved data.")
    if (!confirmed) return
    resetForm()
    try {
      window.localStorage.removeItem("license-data")
    } catch (error) {
      console.warn("Failed to clear license data from localStorage", error)
    }
  }, [resetForm])

  return (
    <div className="mx-auto max-w-7xl grid lg:grid-cols-[60%_40%] gap-4 px-4 sm:px-6 lg:px-8 py-8 sm:py-6">
      <Steps>
        <p className="text-md text-muted-foreground whitespace-pre-line pt-2 pb-2">{s.copy.builderIntro}</p>
        {step(titles.sharing, <Sharing form={form} />)}
        {step("Publishing & Dissemination", <Publishing form={form} />)}
        {step("Attribution", <Attribution form={form} />)}
        {step("Terms", <Conditions form={form} />)}
        {step(titles.datasetDetails, <DatasetDetails form={form} />)}
        {step(titles.licenseDuration, <LicenseDuration form={form} />)}
        {step(titles.benefitSharing, <BenefitSharing form={form} />)}
        {step(titles.costRecovery, <CostRecovery form={form} />)}
      </Steps>
      <Widget visible={widgetVisible} onReset={handleReset} />
    </div>
  )
}
